import { render, staticRenderFns } from "./FilterPurchase.vue?vue&type=template&id=1cbd450e&scoped=true"
import script from "./FilterPurchase.vue?vue&type=script&lang=js"
export * from "./FilterPurchase.vue?vue&type=script&lang=js"
import style0 from "./FilterPurchase.vue?vue&type=style&index=0&id=1cbd450e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd450e",
  null
  
)

export default component.exports